// Single gate for the public-questionnaire redesign (qo-redesign class).
// The redesign is purely cosmetic and must never touch the gamified version
// (ProgressBar, which also drives the mini animation), so this errs toward `false`: no research doc yet,
// or any toggle in any truthy shape → old look. `AIInterviewer` used to gate it
// too; that engine was removed on 2026-09-15 and the flag no longer changes the
// rendering, so a stored 'true' must not keep a research on the old look.
// AI-CONTEXT: See docs/pitfalls.md#ui-togglebutton-string-only-branches

/**
 * Toggle flags are persisted in mixed shapes (boolean true/false AND string
 * 'true'/'false'). Only explicit "off" values count as off; anything else is
 * treated as on, which disables the redesign.
 * @param {*} value - Raw toggle value from the Research doc
 * @returns {boolean} true when the toggle is off
 */
const isOff = (value) =>
  value === undefined || value === null || value === false ||
  value === 'false' || value === '' || value === 0;

/**
 * `isPreview` is de voorbeeldknop in de vragenlijstbouwer. Daar hoort een
 * ontbrekend onderzoeksdocument juist WEL de nieuwe look te geven: 69 van de 358
 * vragenlijsten hangen aan geen enkel onderzoek, en ProgressBar (balk én mini
 * animatie) staat op het onderzoek — zonder onderzoek kan een vragenlijst dus
 * nooit gamified zijn. Op de echte vragenlijst blijft het bij `false`, want daar
 * betekent 'geen document' meestal 'nog aan het laden' en zou een gamified
 * onderzoek eerst de verkeerde weergave krijgen.
 *
 * @param {object|null|undefined} researchDoc - The loaded Research document
 * @param {boolean} [isPreview] - Voorbeeldweergave vanuit de bouwer
 * @returns {boolean} true when the cosmetic redesign may be shown
 */
const isRedesignMode = (researchDoc, isPreview = false) => {
  if (!researchDoc || typeof researchDoc !== 'object') return isPreview === true;
  // De mini animatie is onderdeel van de geanimeerde voortgangsbalk; een
  // achtergebleven `MiniGame`-vlag speelt niet meer en telt dus niet mee.
  return isOff(researchDoc.ProgressBar);
};

export default isRedesignMode;
